// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Kfda","calendarButtons":"ClockData_calendarButtons__253aS"};